import { NavLink } from "react-router-dom";

const SIDEBAR_LINKS = [
  { to: "/legal/terms", label: "Terms of Service" },
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/legal/security", label: "Security" },
  { to: "/legal/business-guidelines", label: "Business Guidelines" },
];

export default function StaticPage({ title, children }) {
  return (
    <div className="bg-muted/40">
      <div className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
        <div className="flex flex-col gap-8 md:flex-row md:gap-10">
          <aside className="shrink-0 md:w-60">
            <nav className="sticky top-24 overflow-hidden rounded-2xl border border-border bg-card p-2 shadow-sm">
              {SIDEBAR_LINKS.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  className={({ isActive }) =>
                    `block rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${
                      isActive
                        ? "bg-primary/10 text-primary"
                        : "text-slate-600 hover:bg-muted hover:text-slate-900"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </aside>
          <div className="min-w-0 flex-1 rounded-2xl border border-border bg-card p-6 shadow-sm sm:p-10">
            <h1 className="font-montserrat text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">
              {title}
            </h1>
            <div className="mt-8 space-y-8 text-[15px] leading-relaxed text-slate-600">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
